const accountsPayableBackdrop     = require('./accountsPayable-backdrop')
const accountsPayableConfirmation = require('./accountsPayable-confirmation')
const accountsPayableDialog       = require('./accountsPayable-dialog')
const accountsPayableDt           = require('./accountsPayable-dt')
const accountsPayableFullcont     = require('./accountsPayable-fullcont')
const accountsPayableMenu         = require('./accountsPayable-menu')
const accountsPayablePage         = require('./accountsPayable-page')
const accountsPayableSnack        = require('./accountsPayable-snack')
const accountsPayableFetch        = require('./accountsPayable-fetch')
const purchaseFullcont2           = require('./purchase2/purchase-fullcont')
const mtpurchaseFullcont2           = require('./purchase2/purchase-fullcont-multitable')

export function start(detail){  //console.log('goku-dt 5>', detail)
         
      obj[detail.elem].start(detail)

}/**/

const obj = {
   
      backdrop:        { start: (detail) =>{  accountsPayableBackdrop.start(detail)         }},
      confirmation:    { start: (detail) =>{  accountsPayableConfirmation.start(detail)     }},
      dialog:          { start: (detail) =>{  accountsPayableDialog.start(detail)           }},
      dt:              { start: (detail) =>{  accountsPayableDt. start(detail)              }},
      fullcont:        { start: (detail) =>{  accountsPayableFullcont. start(detail)        }},
      menu:            { start: (detail) =>{  accountsPayableMenu.start(detail)             }},
      page:            { start: (detail) =>{  accountsPayablePage.start(detail)             }},
      snack:           { start: (detail) =>{  accountsPayableSnack.start(detail)            }},
      fetch:           { start: (detail) =>{  accountsPayableFetch.start(detail)            }},
      purchaseFullcont2:   { start: (detail) =>{  purchaseFullcont2.start(detail)           }},
      mtpurchaseFullcont2:   { start: (detail) =>{  mtpurchaseFullcont2.start(detail)           }},
}